function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.816 8.273l.626 8.061 4.496 5.989-.44.495-5.924-5.783.621-8.762h.621z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.57 23.982A10.962 10.962 0 0116 27C9.925 27 5 22.075 5 16S9.925 5 16 5c.162 0 .323.003.483.01V1.008C16.323 1.003 16.162 1 16 1 7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 4.314 0 8.202-1.82 10.938-4.736l-3.369-2.282zM28.096 23.418A14.121 14.121 0 0030.187 16c0-2.689-.747-5.203-2.047-7.345l-1.601 1.22A12.132 12.132 0 0128.187 16c0 2.348-.663 4.54-1.813 6.4l1.722 1.018z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.256 1.938a3.98 3.98 0 11-5.38 5.38 3.98 3.98 0 005.38-5.38z",
  fill: "currentColor"
})));